import React, { useState } from 'react';
import { useVarianceAppContext } from './VarianceAppContext';
import Badge from './ui/Badge';
import { Filter, ChevronDown, ChevronUp, X } from 'lucide-react';
import './BusinessSegmentFilter.css';

const BusinessSegmentFilter = () => {
  const {
    businessSegments,
    selectedBusinessSegment,
    setSelectedBusinessSegment,
    loading
  } = useVarianceAppContext();

  const [isExpanded, setIsExpanded] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  // Don't render if not visible
  if (!isVisible) {
    return (
      <button
        onClick={() => setIsVisible(true)}
        className="filter-toggle-btn"
      >
        <Filter className="w-5 h-5" />
      </button>
    );
  }

  if (loading && businessSegments.length === 0) {
    return (
      <div className="business-segment-filter loading">
        <div className="filter-header">
          <div className="filter-header-content">
            <div className="filter-icon">
              <Filter className="w-5 h-5 text-white" />
            </div>
            <div>
              <h3 className="filter-title">Global Filter</h3>
              <p className="filter-subtitle">Loading segments...</p>
            </div>
          </div>
          <button
            onClick={() => setIsVisible(false)}
            className="filter-close-btn"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    );
  }

  if (businessSegments.length === 0) {
    return (
      <div className="business-segment-filter error">
        <div className="filter-header">
          <div className="filter-header-content">
            <div className="filter-icon">
              <Filter className="w-5 h-5 text-white" />
            </div>
            <div>
              <h3 className="filter-title">Global Filter</h3>
              <p className="filter-subtitle">No segments available</p>
            </div>
          </div>
          <button
            onClick={() => setIsVisible(false)}
            className="filter-close-btn"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="business-segment-filter-simple">
      <div className="filter-icon-container">
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="filter-icon-btn"
          title={selectedBusinessSegment ? `Selected: ${selectedBusinessSegment}` : 'Select a business segment'}
        >
          <Filter className="w-5 h-5" />
          {selectedBusinessSegment && (
            <div className="active-indicator"></div>
          )}
        </button>
      </div>

      {isExpanded && (
        <div className="filter-dropdown">
          <div className="filter-section">
            <label className="filter-label">Business Segment</label>
            <select
              value={selectedBusinessSegment || ''}
              onChange={(e) => setSelectedBusinessSegment(e.target.value)}
              className="filter-select"
            >
              <option value="">Select a business segment</option>
              {businessSegments.map((segment) => (
                <option key={segment} value={segment}>
                  {segment.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                </option>
              ))}
            </select>
          </div>
        </div>
      )}
    </div>
  );
};

export default BusinessSegmentFilter;
